import optionsApi from "./optionsApi";
import { ForfeitureSettings } from "../types/EsopPlan";

export interface PiiSpan {
  placeholder_id: string;
  label: string;
  original_text: string;
  start: number;
  end: number;
}

export interface RedactResult {
  original_text: string;
  redacted_text: string;
  spans: PiiSpan[];
}

export type JobStatus =
  | { status: "queued" | "processing" }
  | ({ status: "done" } & RedactResult)
  | { status: "failed"; error: string };

export interface CorrectPayload {
  original_text: string;
  spans: PiiSpan[];
  remove: string[];
  add: { original_text: string; label: string }[];
}

/**
 * Step 1: Submit text or DOCX file to privacy filter async worker
 */
export async function prepareForfeitureAI(
  payload: { text: string } | { docx: File }
): Promise<{ job_id: string }> {
  const formData = new FormData();
  if ("docx" in payload) {
    formData.append("file", payload.docx);
  } else {
    formData.append("text", payload.text);
  }

  const response = await optionsApi.post("v1/forfeitureAI/prepare", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data?.data;
}

/**
 * Step 1b: Poll job status
 */
export async function getForfeitureAIStatus(jobId: string): Promise<JobStatus> {
  const response = await optionsApi.get(`v1/forfeitureAI/status/${jobId}`);
  return response.data?.data;
}

/**
 * Step 2: Apply corrections
 */
export async function correctForfeitureAI(
  payload: CorrectPayload
): Promise<RedactResult> {
  const response = await optionsApi.post("v1/forfeitureAI/correct", payload);
  return response.data?.data;
}

/**
 * Step 3: Generate forfeiture JSON from redacted text
 */
export async function generateForfeitureJSON(payload: {
  redacted_text: string;
}): Promise<{ forfeitureJson: ForfeitureSettings }> {
  const response = await optionsApi.post("v1/forfeitureAI/generate", payload);
  return response.data?.data;
}
